<div id="table_graphics" class="tablewrap tabpage hidden">
</div>
